import React from 'react';
import { trackMatchHubClick } from '../../../../libraries/_modules/tracking/helpers';
import PenaltyCardIcon from "../../../shared/svg/PenaltyCardIcon";
import { svgSizes } from "../../../shared/utils";
import { useMatchData } from '../../utils';
import { matchEventTypes } from "../../../mls-match-summary/utils";

function MatchData({ summary, isHome }) {
  const { slug, status, competition } = useMatchData();

  const handleClick = (playerName) => () => {
    trackMatchHubClick({
      clickType: 'player',
      match: slug,
      matchState: status?.abbreviation,
      competition: competition?.shortName,
      playerName
    });
  };

  if (!summary?.length) {
    return null;
  }

  if (!summary || summary.length === 0) {
    return null;
  }

  return (
    <div className={`mls-o-match-strip__match-data mls-o-match-strip__match-data--${isHome ? "home" : "away"}`}>
      {
        summary.map((commentary, index) => {
          const { minute, last_name, known_name, type, first_name } = commentary || {};
          const displayName = known_name
            ? known_name
            : last_name && first_name
              ? `${first_name.charAt(0)}. ${last_name}`
              : last_name
                ? last_name
                : first_name
                  ? first_name
                  : "";

          return (
            <span key={`${minute}-${last_name}-${type}-${index}`} onClick={() => handleClick(displayName)} className={`mls-o-match-strip__commentary mls-o-match-strip__commentary--${commentary.type}`}>
              <span className="mls-o-match-strip__commentary-last-name">{displayName}</span>
              {
                type === "red card" || type === matchEventTypes.secondYellowCard
                  ? (
                    <span className="mls-o-match-strip__commentary-minute">
                      {`(`}
                      <PenaltyCardIcon wrapperElement={"span"} size={svgSizes.xSmall} fill="#d0021b" />
                      {`${minute})`}
                    </span>
                  )
                  : type === matchEventTypes.ownGoal
                    ? <span className="mls-o-match-strip__commentary-minute">{`(${minute} OG)`}</span>
                    : type === matchEventTypes.penaltyGoal
                      ? <span className="mls-o-match-strip__commentary-minute">{`(${minute} PK)`}</span>
                      : <span className="mls-o-match-strip__commentary-minute">{`(${minute})`}</span>
              }{
                summary.length - 1 === index
                  ? ""
                  : ","
              }
            </span>
          );
        })
      }
    </div>
  );
};

// eslint-disable-next-line no-func-assign
MatchData = React.memo(MatchData);

export default MatchData;
